import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Moment from 'moment'
import Table from '@material-ui/core/Table'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import TableBody from '@material-ui/core/TableBody'
import Paper from '@material-ui/core/Paper'
import ErrorIcon from '@material-ui/icons/ErrorOutline'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import Typography from '@material-ui/core/Typography'
import TablePagination from '@material-ui/core/TablePagination'
import TableFooter from '@material-ui/core/TableFooter'
import { DatePicker } from 'material-ui-pickers'
import SkeletonTable from '../../../common/skeleton-table'
import Y from '../../../y18n'
import Styles from '../../../common/styles'
import * as dataHistoryActions from '../../../store/subscriptions-admin/data-history'

const mapStateToProps = state => ({
  dataHistory: state.subscriptionsAdmin.dataHistory
})

const mapDispatchToProps = dispatch => ({
  dataHistoryActions: bindActionCreators(dataHistoryActions, dispatch)
})

class DataHistory extends Component {
  state = {
    sort: { orderBy: 'timestamp', direction: 'asc' },
    fromDate: Moment.utc(new Date()).add(-3, 'days').format(),
    toDate: Moment.utc(new Date()).format(),
    page: 0,
    rowsPerPage: 10
  }

  componentDidMount () {
    if (this.props.id) {
      this.props.dataHistoryActions.getDataHistory(this.props.id, this.state.fromDate, this.state.toDate)
    }
  }

  handleSubmit = e => {
    e.preventDefault()
    this.submit()
  }

  submit = () => {
    this.props.dataHistoryActions.getDataHistory(this.props.id, this.state.fromDate, this.state.toDate)
  }

  handleSortChange = name => event => {
    var direction = this.state.sort.direction === 'asc' ? 'desc' : 'asc'
    this.setState({ sort: { orderBy: name, direction: direction } })
  }

  handleDateChange = (e, name) => {
    this.setState({ [name]: e._d }, () => this.submit())
  }

  render () {
    const { dataHistory, classes } = this.props
    const { fromDate, toDate } = this.state

    if (!dataHistory) return null
    return (
      <div style={{ marginTop: '40px' }}>
        <div className={classes.textRow}>
          <Typography variant='title'>
            {Y`Data history`}
          </Typography>
          <Typography variant='body2'>
            {Y`This table displays the latest data usage. If there are subsequent warnings the camera might be running out of battery`}
          </Typography>
        </div>
        <Paper className={classes.spacer}>
          <div className={classes.content}>
            <form onSubmit={e => this.handleSubmit(e)}>
              <div className={classes.flexRow}>
                <DatePicker
                  keyboard
                  clearable
                  className={classes.flexItemLeft}
                  animateYearScrolling={false}
                  label={Y`From date`}
                  format='YYYY-MM-DD'
                  value={fromDate}
                  onChange={e => this.handleDateChange(e, 'fromDate')}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  InputAdornmentProps={{
                    classes: {
                      root: classes.rightIcon
                    }
                  }}
                />
                <DatePicker
                  keyboard
                  clearable
                  className={classes.flexItemRight}
                  animateYearScrolling={false}
                  label={Y`To date`}
                  format='YYYY-MM-DD'
                  value={toDate}
                  onChange={e => this.handleDateChange(e, 'toDate')}
                  InputProps={{
                    disableUnderline: true,
                    classes: {
                      root: classes.root,
                      input: classes.input
                    }
                  }}
                  InputLabelProps={{
                    shrink: true,
                    className: classes.formLabel
                  }}
                  InputAdornmentProps={{
                    classes: {
                      root: classes.rightIcon
                    }
                  }}
                />
              </div>
            </form>
          </div>
          <div className={classes.tableWrapper}>
            <Table className={'striped'}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.sort.orderBy === 'timestamp'}
                      direction={this.state.sort.direction}
                      onClick={this.handleSortChange('timestamp')}
                    >
                      {Y`Timestamp`}
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.sort.orderBy === 'dataUploaded'}
                      direction={this.state.sort.direction}
                      onClick={this.handleSortChange('dataUploaded')}
                    >
                      {Y`Data uploaded`} (kB)
                    </TableSortLabel>
                  </TableCell>
                  <TableCell>
                    <TableSortLabel
                      active={this.state.sort.orderBy === 'dataDownloaded'}
                      direction={this.state.sort.direction}
                      onClick={this.handleSortChange('dataDownloaded')}
                    >
                      {Y`Data downloaded`} (kB)
                    </TableSortLabel>
                  </TableCell>
                  <TableCell padding='checkbox' />
                </TableRow>
              </TableHead>
              <TableBody>
                {dataHistory.loading
                  ? <SkeletonTable rows={7} cols={4} />
                  : this.state.sort.direction === 'desc'
                      ? dataHistory.history
                          .sort((a, b) => (b[this.state.sort.orderBy] <= a[this.state.sort.orderBy] ? -1 : 1))
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                          )
                          .map(historyEvent => this.renderEvent(historyEvent))
                      : dataHistory.history
                          .sort((a, b) => (a[this.state.sort.orderBy] <= b[this.state.sort.orderBy] ? -1 : 1))
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage + this.state.rowsPerPage
                          )
                          .map(historyEvent => this.renderEvent(historyEvent))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    count={dataHistory.history ? dataHistory.history.length : 0}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onChangePage={this.handleChangePage}
                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </div>
        </Paper>
      </div>
    )
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page })
  }

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value })
  }

  renderEvent (historyEvent) {
    return (
      <TableRow key={historyEvent.timestamp}>
        <TableCell>
          {Moment.utc(historyEvent.timestamp).local().format('YYYY-MM-DD HH:mm:ss')}
        </TableCell>
        <TableCell>{historyEvent.dataUploaded}</TableCell>
        <TableCell>{historyEvent.dataDownloaded}</TableCell>
        <TableCell padding='checkbox'>
          {historyEvent.warning ? <ErrorIcon style={{ color: 'red' }} title={Y`Warning`} /> : ''}
        </TableCell>
      </TableRow>
    )
  }
}

DataHistory = connect(mapStateToProps, mapDispatchToProps)(DataHistory)
export default withStyles(Styles)(DataHistory)



// WEBPACK FOOTER //
// ./src/pages/subscription-details/containers/data-history.js